import { useState } from "react";

import { SWReactCountryIcons } from "@similarweb/icons";
import { colorsPalettes, elevation } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { CAMPAIGN_WIZARD_TRANSLATIONS } from "app/pages/digital-marketing/monitor-and-protect/shared/components/create-campaign-wizard/translations";

interface IICountryListItemProps {
    countryName: string;
    countryCode: number;

    isSelected: boolean;
    onClick: () => void;
}

export const CountryListItem = ({ countryName, countryCode, isSelected, onClick }: IICountryListItemProps) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Flex
            as="li"
            tabIndex={0}
            justifyContent="space-between"
            alignItems="center"
            onClick={onClick}
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    onClick();
                }
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            padding="6px 8px 6px 16px"
            transition="box-shadow 0.2s ease-in-out"
            borderRadius="3px"
            cursor="pointer"
            whenHover={{
                boxShadow: elevation.Z1,
            }}
            border={`1px solid ${colorsPalettes.carbon["50"]}`}
        >
            <Flex
                gap="8px"
                alignItems="center"
            >
                <SWReactCountryIcons
                    size="sm"
                    countryCode={countryCode}
                />
                <Text fontVariant="input2">{countryName}</Text>
            </Flex>
            <IconButton
                type="flat"
                iconName={isHovered && isSelected ? "delete" : isSelected ? "checked" : "add"}
                onClick={(e) => {
                    e.stopPropagation();
                    onClick();
                }}
            >
                {isHovered && isSelected
                    ? CAMPAIGN_WIZARD_TRANSLATIONS.countries.deleteButton.translate()
                    : isSelected
                      ? CAMPAIGN_WIZARD_TRANSLATIONS.countries.addedButton.translate()
                      : CAMPAIGN_WIZARD_TRANSLATIONS.countries.addButton.translate()}
            </IconButton>
        </Flex>
    );
};
